import { Navigate } from 'react-router-dom';
import { lazy } from 'react';

// project imports
import MainLayout from 'views/components/layout/MainLayout';
import Loadable from 'views/components/ui-component/Loadable';

// lazy load all components
const ClinicalService = Loadable(lazy(() => import('views/pages/service/clinical')));
const ClinicalDetail = Loadable(lazy(() => import('views/pages/service/clinical/ClinicalDetail')));
const ClinicalRegister = Loadable(lazy(() => import('views/pages/service/clinical/ClinicalRegister')));

// ==============================|| IT STAFF ROUTES ||============================== //

const ClinicalRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="/service/clinical" replace />
        },
        {
            path: 'service',
            children: [
                {
                    path: 'clinical',
                    children: [
                        {
                            path: ':id',
                            element: <ClinicalDetail />
                        },
                        {
                            path: 'detail/:id/edit',
                            element: <ClinicalDetail />
                        },
                        {
                            path: 'register',
                            element: <ClinicalRegister />
                        },
                        {
                            path: '',
                            element: <ClinicalService />
                        },
                        {
                            path: '*',
                            element: <ClinicalService />
                        }
                    ]
                }
            ]
        },
        {
            path: '*',
            element: <Navigate to="/service/clinical" replace />
        }
    ]
};

export default ClinicalRoutes;
